const PERK_REDEEM_CODES = {
  INVALID_REQUEST: 'Cannot change, once a purchase has occured.',
  ADDED: 'Perk Redeem Code added.',
  EDITED: 'Perk Redeem Code edited.',
  DELETED: 'Perk Redeem Code deleted.',
  PERK_ID_REQUIRED: 'Perk id is required.',
  COMPLETED: 'Redeem Codes added successfully.',
  FAILED: 'Failed to add requested redeem Codes.',
  LIMIT_REACHED: (redeemCodesImportLimit: number): string =>
    `Limit reached, can not add more than ${redeemCodesImportLimit} redeem codes at a time.`,
  NO_FILE_FOUND: 'No file found to import data.',
  NO_REDEEM_CODE_AVAILABLE:
    'No Perk code available right now, try again later.',
  INVALID_REDEEM_CODE: 'Invalid redeem code found, please try again later.',
  DUPLICATE_RECORDS_FOUND: (unique: string, duplicate: string): string =>
    `${unique} unique codes added.\nFound ${duplicate} duplicate codes, which were skiped.`,
  INVALID_RECORDS_FOUND: (unique: string, invalid: string): string =>
    `${unique} unique codes added.\nFound ${invalid} invalid codes, which were skiped.`,
  DUPLICATE_INVALID_RECORDS_FOUND: (
    unique: string,
    duplicate: string,
    invalid: string
  ): string =>
    `${unique} unique codes added.\nFound ${duplicate} duplicate codes & ${invalid} invalid codes, which were skiped.`,
  REDEEM_CODE_DUPLICATE_IN_ALL_PERKS:
    'Redeem Code already available in other perk.',
} as const;

export default PERK_REDEEM_CODES;
